import { VolumeX } from 'lucide-react';
import { useTranslate } from 'ra-core';

export const ChannelUserCardMuted = () => {
  const translate = useTranslate();

  return (
    <span className="absolute right-[-14px] bottom-0 flex size-[54px] items-center justify-center rounded-full bg-background/80">
      <VolumeX
        className="size-8 text-primary"
        aria-label={translate('chat.muted')}
      />
    </span>
  );
};
